import { useEffect, useState } from "react";
import { fetchConfigValueAsync } from "../services/configuration/config.ts";

type ConfigValues = {
  isCloud: boolean | null;
  isOPIC: boolean | null;
  appPath: string;
};

let cachedConfigPromise: Promise<ConfigValues> | null = null;

export const resetConfigCache = (): void => {
  cachedConfigPromise = null;
};

const useConfig = (): ConfigValues & { resetConfigCache: () => void } => {
  const [isCloud, setIsCloud] = useState<boolean | null>(null);
  const [isOPIC, setIsOPIC] = useState<boolean | null>(null);
  const [appPath, setAppPath] = useState<string>("");

  useEffect(() => {
    let isMounted = true;

    const getConfigValues = async () => {
      if (!cachedConfigPromise) {
        cachedConfigPromise = fetchConfigValueAsync().then((config) => ({
          isCloud: config?.environmentType?.toLowerCase() !== "onprem",
          isOPIC: config?.authenticationType?.toLowerCase() === "opic",
          appPath: config?.appPath || "",
        }));
      }

      const config = await cachedConfigPromise;
      if (isMounted) {
        setIsCloud(config.isCloud);
        setIsOPIC(config.isOPIC);
        setAppPath(config.appPath);
      }
    };

    getConfigValues();

    return () => {
      isMounted = false;
    };
  }, []);

  return { isCloud, isOPIC, appPath, resetConfigCache };
};

export default useConfig;
